import {
  FaMapMarkerAlt,
  FaUmbrellaBeach,
  FaRegClock,
  FaPlane,
  FaStar,
} from "react-icons/fa";
import ExperienceLayout from "./ExperienceLayout";
import imageStoneTown from "../../assets/ZANZIBAR5.jpg";
import imageNungwi from "../../assets/banner1.jpg";
import imageActivities from "../../assets/sunflower.jpg";
import imageHotel from "../../assets/zanzibar1.jpg";

const hero = {
  kicker: "Bush to Beach Safaris",
  title: "Wildlife + Coastal Balance",
  subtitle:
    "Combine private Serengeti game drives with Zanzibar’s turquoise beaches for an effortless Tanzanian escape.",
  backgroundImage: imageNungwi,
  meta: ["Private transfers", "Serengeti & Zanzibar", "Cultural insights"],
};

const overview =
  "Begin with world-class wildlife in Tanzania's safari heartlands—Serengeti, Ngorongoro, and Ngorongoro Crater—before unwinding on Zanzibar's turquoise coast. Tailored guides keep you close to the Big Five while beachside stays offer culinary and marine delights.";

const highlights = [
  {
    icon: FaMapMarkerAlt,
    title: "Serengeti immersion",
    description: "Private game drives in the Serengeti and Ngorongoro for Big Five encounters.",
  },
  {
    icon: FaUmbrellaBeach,
    title: "Island recovery",
    description: "Sleep on Zanzibar’s palm-fringed beaches with snorkel, spice, and ocean experiences.",
  },
  {
    icon: FaStar,
    title: "Cultural connections",
    description: "Maasai village visits, sunset sundowners, and guided interpretation throughout.",
  },
  {
    icon: FaPlane,
    title: "Seamless logistics",
    description: "Private transfers, luxury camps, and concierge support from safari to shore.",
  },
];

const details = [
  {
    icon: FaMapMarkerAlt,
    title: "Destinations",
    description: "Serengeti, Ngorongoro Crater, and Zanzibar across Tanzania.",
  },
  {
    icon: FaRegClock,
    title: "Best time to travel",
    description: "June–October and December–March combine excellent wildlife and beach weather.",
  },
];

const itinerary = [
  {
    dayLabel: "Day 1 • Arrival & Safari Intro",
    title: "Land in Arusha, move to the Serengeti",
    image: imageStoneTown,
    body: "Touch down in Kilimanjaro or Arusha, meet your guide, and chase sunset across the plains while setting the focus for your safari.",
    activities: "Arrival, briefing, lodge stay",
  },
  {
    dayLabel: "Day 2 • Serengeti Game Drives",
    title: "Track predators and migration",
    image: imageHotel,
    body: "Explore the Serengeti’s plains with private guides, pause for gourmet lunch, and cap the afternoon with exclusive wildlife watching.",
    activities: "Game drives, photography",
  },
  {
    dayLabel: "Day 3 • Zanzibar Beach",
    title: "White sand and turquoise waters",
    image: imageActivities,
    body: "Fly to Zanzibar and swap the savannah for palm trees—enjoy snorkeling, spice tours, and relaxation at a premium beach resort.",
    activities: "Beach leisure, marine activities",
  },
];

export default function BushToBeach() {
  return (
    <ExperienceLayout
      hero={hero}
      overview={overview}
      highlights={highlights}
      details={details}
      itinerary={itinerary}
    />
  );
}
